export class SaldoFavorCalculo {
	public static maximoAplicable(saldoDisponible: number, totalElegible: number): number {
		const saldo = Math.max(0, Math.floor(Number(saldoDisponible) || 0));
		const total = Math.max(0, Math.floor(Number(totalElegible) || 0));
		return Math.min(saldo, total);
	}

	public static diferenciaPago(total: number, saldoAplicado: number): number {
		const totalEntero = Math.max(0, Math.floor(Number(total) || 0));
		const saldoEntero = Math.max(0, Math.floor(Number(saldoAplicado) || 0));
		return Math.max(0, totalEntero - saldoEntero);
	}

	public static totalesConDescuentoNeto(neto: number, saldoAplicado: number): {
		neto: number;
		iva: number;
		total: number;
	} {
		const netoOriginal = Math.max(0, Math.round(Number(neto) || 0));
		const descuentoNeto = Math.min(
			netoOriginal,
			Math.max(0, Math.floor(Number(saldoAplicado) || 0))
		);
		const netoPagar = netoOriginal - descuentoNeto;
		const ivaPagar = Math.round(netoPagar * 0.19);
		return {
			neto: netoPagar,
			iva: ivaPagar,
			total: netoPagar + ivaPagar,
		};
	}
}
